import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="field-view-toggle"
// Toggles between list and map views, persisting preference to localStorage.
export default class extends Controller {
  static targets = ["list", "map", "listBtn", "mapBtn"]
  static values  = { key: String }

  connect() {
    const saved = localStorage.getItem(this._key)
    if (saved === "map") {
      this._showMap()
    } else {
      this._showList()
    }
  }

  showList() {
    this._showList()
    localStorage.setItem(this._key, "list")
  }

  showMap() {
    this._showMap()
    localStorage.setItem(this._key, "map")
  }

  _showList() {
    this.listTargets.forEach(el => el.classList.remove("hidden"))
    this.mapTargets.forEach(el => el.classList.add("hidden"))
    this._activateBtn(this.listBtnTarget)
    this._deactivateBtn(this.mapBtnTarget)
  }

  _showMap() {
    this.listTargets.forEach(el => el.classList.add("hidden"))
    this.mapTargets.forEach(el => el.classList.remove("hidden"))
    this._activateBtn(this.mapBtnTarget)
    this._deactivateBtn(this.listBtnTarget)
    // Map may have initialised while hidden — resize so it fills its container
    window.dispatchEvent(new CustomEvent("field-places-map:resize"))
  }

  _activateBtn(btn) {
    btn.classList.add("bg-white", "shadow-sm", "text-slate-800")
    btn.classList.remove("text-slate-500")
  }

  _deactivateBtn(btn) {
    btn.classList.remove("bg-white", "shadow-sm", "text-slate-800")
    btn.classList.add("text-slate-500")
  }

  get _key() {
    return `field_view_${this.keyValue}`
  }
}
